export default __webpack_public_path__ + "static/media/Close.235cbfcd.webp";